/* global BASE_URL PATH_PREFIXES */
const originalBaseUrl = BASE_URL || '/';
const pathPrefixes = PATH_PREFIXES || [];

let match: RegExpMatchArray | null = null;
if (typeof window !== 'undefined') {
  let n = pathPrefixes.length;
  while (match === null && n > 0) {
    const regexp = new RegExp(`(${pathPrefixes[--n]})${originalBaseUrl.slice(1)}`);
    match = regexp.exec(window.location.pathname);
  }
}

export const baseUrl = (match?.[0]) || originalBaseUrl;
export const rootDir = (match?.[1]) || '';
export const applianceId = (match?.[2]) || null;
export const rootPath = rootDir.replace(/\/$/, '');
